import { TIPTAP_COLLAPSIBLE_LIST_TYPE } from 'ricos-content';

function findParentNodeClosestToPos($pos, predicate) {
  for (let i = $pos.depth; i > 0; i -= 1) {
    const node = $pos.node(i);
    if (predicate(node)) {
      return {
        pos: i > 0 ? $pos.before(i) : 0,
        start: $pos.start(i),
        depth: i,
        node
      };
    }
  }
}
function findChildren(node, predicate) {
  const nodesWithPos = [];
  node.descendants((child, pos) => {
    if (predicate(child)) {
      nodesWithPos.push({
        node: child,
        pos
      });
    }
  });
  return nodesWithPos;
}
function updateCollapsibleListAttrs(commands, nodeId, attrs) {
  commands.updateNodeAttrsById(nodeId, attrs);
}
function updateCollapsibleListItemsAttrs(state, commands, nodeId, { initialExpandedItems }) {
  const collapsibleListNode = findNodeById(state, nodeId)[0].node;
  const items = collapsibleListNode.content.content;
  items.forEach((node, index) => {
    const isExpanded = initialExpandedItems === "ALL" || index === 0 && initialExpandedItems === "FIRST";
    updateListItemAttributes(commands, node, {
      isExpanded
    });
  });
}
function updateListItemAttributes(commands, node, attrs) {
  commands.updateNodeAttrsById(node.attrs.id, attrs);
  commands.updateNodeAttrsById(node.content.content[1].attrs.id, attrs);
}
function isInCollapsibleList($pos, nodeId) {
  var _a;
  const collapsibleListNode = (_a = findParentNodeClosestToPos(
    $pos,
    (node) => {
      var _a2;
      return ((_a2 = node.type) == null ? void 0 : _a2.name) === TIPTAP_COLLAPSIBLE_LIST_TYPE;
    }
  )) == null ? void 0 : _a.node;
  return collapsibleListNode == null ? void 0 : collapsibleListNode.content.content.some((node) => node.attrs.id === nodeId);
}
function findCollapsibleListById(state, nodeId) {
  let collapsibleList;
  state.doc.descendants((node) => {
    if (node.attrs.id === nodeId) {
      collapsibleList = node;
    }
  });
  return collapsibleList;
}
function getCollapsibleListItems(state, nodeId) {
  const collapsibleListNode = findCollapsibleListById(state, nodeId);
  if ((collapsibleListNode == null ? void 0 : collapsibleListNode.type.name) === TIPTAP_COLLAPSIBLE_LIST_TYPE) {
    return collapsibleListNode.content.content;
  }
  return [];
}
function getCollapsibleListByItemId(state, nodeId) {
  const collapsibleLists = findNodesByType(state, TIPTAP_COLLAPSIBLE_LIST_TYPE);
  let collapsibleList;
  collapsibleLists.forEach((listNode) => {
    listNode.node.descendants((node) => {
      if (node.attrs.id === nodeId) {
        collapsibleList = listNode.node;
        return;
      }
    });
  });
  return collapsibleList;
}
const getFirstTextNodeDirectionFromAlignment = (node) => {
  var _a, _b, _c;
  if ((_b = (_a = node.attrs) == null ? void 0 : _a.textStyle) == null ? void 0 : _b.textAlignment) {
    return getTextDirectionFromAlignment((_c = node == null ? void 0 : node.attrs.textStyle) == null ? void 0 : _c.textAlignment);
  }
  return node.firstChild ? getFirstTextNodeDirectionFromAlignment(node.firstChild) : void 0;
};
const getTextDirectionFromAlignment = (textAlignment) => textAlignment === "RIGHT" ? "rtl" : textAlignment === "LEFT" ? "ltr" : void 0;
const findNodesByType = (state, type) => {
  const predicate = (node) => node.type.name === type;
  return findChildren(state.doc, predicate);
};
const findNodeById = (state, id) => {
  const predicate = (node) => node.attrs.id === id;
  return findChildren(state.doc, predicate);
};

export { findChildren, findCollapsibleListById, findNodeById, findNodesByType, findParentNodeClosestToPos, getCollapsibleListByItemId, getCollapsibleListItems, getFirstTextNodeDirectionFromAlignment, isInCollapsibleList, updateCollapsibleListAttrs, updateCollapsibleListItemsAttrs, updateListItemAttributes };
//# sourceMappingURL=utils.js.map
